module.exports = __webpack_public_path__ + "img/2025-03-12a_1.2549eb9c.jpg";